export const  toggleNew = (newproduct) => {
  if(newproduct === true) {
    return true
  } else {
    return false
  }
};
